/**
 * The origin the web app sends API requests to. `VITE_PIEVE_API_BASE_URL` wins when it is set at
 * build time; otherwise requests go to the page's own origin, where the dev server (and, later, the
 * host) forwards `/v1` to the API. Same origin is what lets the browser send the session cookie.
 */
const resolvePieveApiBaseUrl = () => {
  const explicitApiBaseUrl = String(import.meta.env?.VITE_PIEVE_API_BASE_URL || '')
    .trim()
    .replace(/\/$/, '');

  if (explicitApiBaseUrl) {
    return explicitApiBaseUrl;
  }

  return typeof window === 'undefined' ? '' : window.location.origin;
};

export default resolvePieveApiBaseUrl;
